(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["testimonial-grid"] && !window.DesignMode) return;
  try {
    
  (function(){
    var root = document.getElementById('tgrid-{{ section.id }}');
    if(!root) return;
    var wrap = root.querySelector('[data-scrollwrap]');
    function scrollByCard(dir){
      if(!wrap) return;
      var card = wrap.querySelector('.tgrid__card');
      var styles = getComputedStyle(wrap);
      var gap = parseFloat(styles.columnGap || styles.gap || 20);
      var delta = card ? (card.getBoundingClientRect().width + gap) : 320;
      wrap.scrollBy({ left: dir * delta, behavior: 'smooth' });
    }
    var prev = root.querySelector('.tgrid__arrow--prev');
    var next = root.querySelector('.tgrid__arrow--next');
    if(prev) prev.addEventListener('click', function(){ scrollByCard(-1); });
    if(next) next.addEventListener('click', function(){ scrollByCard(1); });
  })();
  
  } catch(e) { console.error(e); }
})();
})();
